import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import * as React from "react";
import { GetCountriesReferentialQuery } from "../../../api";
import { useReferential } from "../../../hooks/useReferential";

export interface IFGCountrySelectProps extends IFGSelectInputProps<any> {
  name: string;
  label: string;
  includeBelgium?: boolean;
}

export const FGCountrySelect: React.FunctionComponent<IFGCountrySelectProps> = (props) => {
  const belgium = React.useMemo(
    () => (props.includeBelgium === null || props.includeBelgium === undefined ? true : props.includeBelgium),
    [props.includeBelgium]
  );
  const [countries, cloading] = useReferential(
    (a) => a.getCountries(new GetCountriesReferentialQuery({ includeBelgium: belgium })),
    true,
    [props.includeBelgium]
  );

  return <FGSelectInput loading={cloading} items={countries} {...props} />;
};
